export default "__VITE_ASSET__CKLrz9MT__"